export default __webpack_public_path__ + "static/media/udacity-logo-vertical.3cde14d8.svg";